import { Search } from "lucide-react";
import React from "react";
import { useDispatch } from "react-redux";
import { useImmer } from "use-immer";

import {
  IgButton,
  IgTextField,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import { Drawer, Grid } from "@mui/material";
import {
  AnalyticFiltersConfigType,
  DashboardPageName,
} from "@src/api/types/dashboards";
import { AnalyticsAccordion } from "@src/features/analytics/analyticsFilters/AnalyticsAccordion";
import { closeDrawer } from "@src/store/slices/drawers";

interface AnalyticsFiltersDrawerProps {
  isSaveLoading?: boolean;
  isSaveDisabled?: { isDisabled: boolean; reason: string };
  onFilterSave: () => void;
  openFilters: boolean;
  onFiltersClearAll: () => void;
  filterButtons: AnalyticFiltersConfigType[];
  pageName?: DashboardPageName;
}
export const AnalyticsFiltersDrawer = ({
  isSaveDisabled,
  onFilterSave,
  openFilters,
  isSaveLoading,
  onFiltersClearAll,
  pageName,
  filterButtons,
}: AnalyticsFiltersDrawerProps) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useImmer<string>("");
  return (
    <Drawer
      anchor="right"
      open={openFilters}
      onClose={() => {
        dispatch(closeDrawer("analyticsFilters"));
      }}
      sx={{
        zIndex: 1400,
        ".MuiDrawer-paper": { borderRadius: "0 !important", width: "500px" },
      }}
    >
      <Grid
        direction="column"
        rowSpacing={2}
        container
        sx={{
          height: "100%",
          display: "flex",
          flexWrap: "nowrap",
          padding: "20px",
        }}
      >
        <Grid
          item
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item>
            <IgTypography fontWeight={600} variant={"h2"}>
              Filters
            </IgTypography>
          </Grid>
          <Grid item>
            <IgButton color={"secondary"} onClick={onFiltersClearAll}>
              Clear All
            </IgButton>
          </Grid>
        </Grid>
        <Grid item marginTop={"15px"}>
          <IgTextField
            placeholder={"Search"}
            InputProps={{
              endAdornment: <Search size={16} />,
            }}
            fullWidth
            value={search ?? ""}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Grid>
        <Grid item>
          <AnalyticsAccordion
            filterButtons={filterButtons}
            pageName={pageName}
            search={search}
          />
        </Grid>
        <Grid
          container
          direction={"row"}
          justifyContent={"flex-end"}
          paddingY={"20px"}
        >
          <IgTooltip title={isSaveDisabled?.reason || ""}>
            <IgButton
              disabled={isSaveDisabled?.isDisabled}
              onClick={onFilterSave}
              loading={isSaveLoading}
            >
              Save Filters
            </IgButton>
          </IgTooltip>
        </Grid>
      </Grid>
    </Drawer>
  );
};
